import { render } from "./Regular.vue?vue&type=template&id=6d5eae2a"
import script from "./Regular.vue?vue&type=script&lang=js"
export * from "./Regular.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__